import { ShopSubscription } from 'shared/types/shop';

export const creditSphereInitialSubscription = (
  subscriptionsData: ShopSubscription[],
): ShopSubscription | undefined =>
  subscriptionsData?.find(subscription => {
    const produtName = subscription.name.toLowerCase();
    return (
      subscription.categories?.find(category => category === 'Credit Analysis') &&
      subscription.productLines?.find(productLine => productLine === 'Rating') &&
      produtName.includes('europe') &&
      produtName.includes('full')
    );
  });

export const creditSphereSubscriptionId = (
  subscriptionsData: ShopSubscription[],
): number | undefined => creditSphereInitialSubscription(subscriptionsData)?.id;
